module.exports = __webpack_public_path__ + "portal-static/img/2.f7e3be27.jpg";